import { Stack } from 'components/Stack';
import { Text } from 'components/Typography';
import { ReactComponent as IcData } from 'constants/icon/ic_data.svg';
import React, { CSSProperties, ReactNode } from 'react';

type TTableLayoutProps = {
  children: React.ReactNode;
  title: React.ReactNode | string;
  desc: React.ReactNode | string;
  sx?: CSSProperties;
  closeButton?: React.ReactNode;
};

const TableLayout = ({ sx = { padding: '50px 24px 20px 20px' }, ...props }: TTableLayoutProps) => {
  const ITS = (t: any): boolean => {
    return typeof t === 'string';
  };
  return (
    <Stack className="setting-layout-TnD" align="start" sx={sx}>
      <Stack className="setting-layout-title setting-layout-sc" direction="row" justify="space-between">
        <Stack spacing={10} direction="row" sx={{ width: 'max-content' }}>
          {React.createElement(IcData, {
            width: 24,
            height: 24,
          })}
          {ITS(props.title) ? (
            <Text styleName="title1" sx={{ width: 'max-content' }}>
              {props.title}
            </Text>
          ) : (
            props.title
          )}
        </Stack>
        {props?.closeButton && props?.closeButton}
      </Stack>
      <Stack className="setting-layout-desc" align="start" sx={{ marginTop: '10px', marginLeft: 32 }}>
        {ITS(props.desc) ? <Text styleName="caption2">{props.desc}</Text> : props.desc}
      </Stack>
      <Stack align="start" sx={{ marginTop: '30px' }}>
        {props.children}
      </Stack>
    </Stack>
  );
};

export default TableLayout;
